import React, { Component } from "react";
import { Link } from "react-router-dom";
import AppContext from "../../../contexts/AppContext";
import { resendResetEmail } from "../../../services/user";

export class RecoverEmailSent extends Component {
    handleResend = () => {
        resendResetEmail({ email: this.context.state.recoverEmail })
            .then(res => {
                this.context.state.showCodeMessage(
                    "We sent your recover email again!",
                    "success"
                );
            })
            .catch(err => {
                this.context.state.showCodeMessage(
                    "failed to send recover email again!",
                    "danger"
                );
            });
    };
    render() {
        return (
            <div className="container-fluid" style={{ height: "100vh" }}>
                <div className="row align-items-center justify-content-center h-100">
                    <div className="col-12 col-md-5 col-lg-6 col-xl-4">
                        <div className="text-center">
                            <img className="d-block m-auto" src="/images/email.png" alt="email sent" />
                        </div>
                        <h1 className="display-4 text-center mb-3 w-100">
                            We sent you an email with a link to reset your password.
                        </h1>
                        {this.context.state.recoverEmail != null ? (
                            <div className="form-group small text-center">
                                Haven't received it?
								<Link
                                    onClick={this.handleResend}
                                    className="form-text small text-muted d-inline-flex font-weight-bold text-dark ml-2"
                                >
                                    Click here to resend.
                                </Link>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
RecoverEmailSent.contextType = AppContext;
export default RecoverEmailSent;



// WEBPACK FOOTER //
// ./src/components/auth/messages/RecoverEmailSent.js